export const getUrlParam = (key: string): string | null => {
  const url = new URL(window.location.href);
  return url.searchParams.get(key);
};
